import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-5" }

import { ref, watch, onMounted } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon, ExclamationCircleIcon  } from '@heroicons/vue/24/outline'


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
  message: String,
  success: Boolean
},
  setup(__props) {

const props = __props;



let message = ref(props.message) 
let success = ref(props.success)
const show = ref(false)

const close = () => {
  show.value = false
  setTimeout(() => console.log('close'), 300)
}

watch(() => props.message, newVal => {
  message.value = newVal // Update the message whenever the prop changes
})

watch(() => props.success, newVal => {
  success.value = newVal // Update the success status whenever the prop changes
})

watch(() => success.value, newVal => { // Watch the success status
  show.value = newVal
  if (newVal) {
    setTimeout(() => {
      close()
    }, 3000)
  }
})

onMounted(() => {
  show.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: show.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: close
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["mx-auto flex h-12 w-12 items-center justify-center rounded-full", {'bg-green-100': _unref(success), 'bg-red-100': !_unref(success)}])
                        }, [
                          (_unref(success))
                            ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                key: 0,
                                class: "h-6 w-6 text-green-600",
                                "aria-hidden": "true"
                              }))
                            : (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
                                key: 1,
                                class: "h-6 w-6 text-red-600",
                                "aria-hidden": "true"
                              }))
                        ], 2),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_unref(DialogTitle), {
                            as: "h3",
                            class: "text-base font-semibold leading-6 text-gray-900"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(message)), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})